import { useLocation } from 'react-router-dom';
import HeaderMenuTab from './components/HeaderMenuTab';
import HeaderMenuOverflow from './components/HeaderMenuOverflow';
import StyledDesktopHeaderMenuItems from './styles';
import useDesktopHeaderMenuItemsService from './useDesktopHeaderMenuItemsService';

const DesktopHeaderMenuItems = () => {
  const { pathname } = useLocation();
  const { overflowTabs, visibleTabs, containerRef } = useDesktopHeaderMenuItemsService();

  return (
    <StyledDesktopHeaderMenuItems>
      <div className="header-menu__container" ref={containerRef}>
        {visibleTabs.map(item => (
          <HeaderMenuTab key={`${item.url}-${item.name}`} item={item} pathname={pathname} />
        ))}
      </div>
      {overflowTabs.length > 0 && <HeaderMenuOverflow items={overflowTabs} pathname={pathname} />}
    </StyledDesktopHeaderMenuItems>
  );
};

export default DesktopHeaderMenuItems;
